/** legend and badge swatch, same fill and stroke as the pitch-report dots */

export const LegendDot = (props: { color: string; size?: number }) => {
  const diameter = props.size ?? 8;
  const box = diameter + 2;

  return (
    <svg
      style={{
        display: 'inline-block',
        flexShrink: 0,
        borderRadius: '50%',
      }}
      width={box}
      height={box}
      viewBox={`0 0 ${box} ${box}`}
      aria-hidden
    >
      <circle
        cx={box / 2}
        cy={box / 2}
        r={diameter / 2}
        fill={props.color}
        fillOpacity={0.75}
        stroke={props.color}
        strokeWidth={1}
      />
    </svg>
  );
};
